module.exports = __webpack_public_path__ + "img/20210906-1630910982683497.f7f8a079.jpg";